import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../pages/PropertyDetails/propertydetails.css";
import Header from "../../components/Navbar";
import Map from "../../myimgs/Group 27.png";
import Home from "../../myimgs/home1.png";
import BAD from "../../myimgs/bads.png";
import BATH from "../../myimgs/bath.png";
import Size from "../../myimgs/size.png";
import pdf from "../../myimgs/pdf.png";
import Slider from "../../components/slider/slider";
import Footer from "../../components/footer/footer";
import nodata from "../../myimgs/Group 232.png";
import Swal from "sweetalert2";
import socketService from "../../utils/socket";
import Loader from "../../components/Loader/loader";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function Mylistingview() {
  const hash = window.location.hash;
  const navigate = useNavigate();
  // const propertyId = hash ? hash.replace("#", "") : null;
  const propertyId = localStorage.getItem("selectedPropertyId");
  const userId = localStorage.getItem("userId");
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [propertyData, setPropertyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [mainImage, setMainImage] = useState(null);
  const [thumbImages, setThumbImages] = useState([]);

  useEffect(() => {
    const fetchPropertyDetails = async () => {
      if (!propertyId) {
        setError("❌ Property ID not found in URL.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${baseUrl}/property/${propertyId}`);

        if (response.data.status === 200) {
          const data = response.data.data;
          setPropertyData(data);

          // Images
          if (data.propertyImages?.length > 0) {
            setMainImage(data.propertyImages[0].imageUrl);
            setThumbImages(data.propertyImages.slice(1));
          }
        } else {
          setError("Failed to fetch property details");
        }
      } catch (err) {
        console.error(err);
        setError("Error fetching property data");
      } finally {
        setLoading(false);
      }
    };

    fetchPropertyDetails();
  }, [propertyId, userId, baseUrl]);

  const handleThumbClick = (clickedImage) => {
    if (!clickedImage || !mainImage) return;

    // Swap main and clicked image
    const updatedThumbs = thumbImages.map((img) =>
      img.imageUrl === clickedImage.imageUrl ? { imageUrl: mainImage } : img
    );
    setMainImage(clickedImage.imageUrl);
    setThumbImages(updatedThumbs);
  };

  if (loading)
    return (
      <div className="loader-wrapper">
        <div className="loader"></div>
      </div>
    );

  if (error) return <div className="error">{error}</div>;
  if (!propertyData) return null;

  const {
    propertyName,
    propertyType,
    streetAddress,
    city,
    state,
    zipcode,
    country,
    propertySize,
    bedRooms,
    bathroms,
    halfBathrooms,
    marketingDescription,
    user,
    textDisclaimer,
    docDisclaimer,
    totalRooms,
  } = propertyData;
  // timersss  ...
  function Countdown({ start, end }) {
    const [timeLeft, setTimeLeft] = useState("");

    // ✅ Format date as "DD-MM-YYYY, HH:MM"
    const formatDateTime = (dateString) => {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}-${month}-${year}, ${hours}:${minutes}`;
    };

    const getRemainingTime = (startTime, endTime) => {
      const now = new Date();
      const startDate = new Date(startTime);
      const endDate = new Date(endTime);

      // ✅ Before auction starts
      if (now < startDate) {
        return (
          <>
            <span className="aucnt">Offer Starting Date</span> <br />
            {formatDateTime(startDate)}
          </>
        );
      }

      const diff = endDate - now;

      // ✅ After Offer Ended
      if (diff <= 0) {
        return <span className="aucnt">Offer Ended</span>;
      }

      // ✅ While auction is active
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);
    };

    useEffect(() => {
      const interval = setInterval(() => {
        setTimeLeft(getRemainingTime(start, end));
      }, 1000);

      return () => clearInterval(interval);
    }, [start, end]);

    return <h3>{timeLeft}</h3>;
  }
  // timersss  ...

  const handleViewDetails = (id) => {
    localStorage.setItem("selectedPropertyId", id);
    navigate("/purchagdetails");
  };
  return (
    <>
      <Header />
      <div className="property-detail-page scrolleffect">
        {/* Tabs */}
         {/* Tabs */}
        <div className="tabs">
          <div className="btnflx">
            <button
              onClick={() =>
                document
                  .getElementById("Overview")
                  .scrollIntoView({ behavior: "smooth" })
              }
            >
              Overview
            </button>
            <button
              onClick={() =>
                document
                  .getElementById("PropertyDetails")
                  .scrollIntoView({ behavior: "smooth" })
              }
            >
              Property Details
            </button>

            <button
              onClick={() =>
                document
                  .getElementById("RecommendedProperties")
                  .scrollIntoView({ behavior: "smooth" })
              }
            >
              Recommended Properties
            </button>
          </div>
          <Link to="/booktours">
            <button className="booktour">Book a Tour</button>
          </Link>
        </div>

        <div className="main-section" id="Overview">
          {/* Left Gallery */}
          <div className="gallery-section">
            <div className="gallery-grid">
              {/* Left Big Image */}
              <div className="main-photo">
                <img
                  src={mainImage || "https://picsum.photos/800/500?random=1"}
                  alt="Main Property"
                />
                {/* <div className="gallery-buttons">
                  <button>
                    <img src={Gallery} alt="" />
                    Gallery
                  </button>
                  <button>
                    <img src={Map} alt="" />
                    Map View
                  </button>
                  <button>
                    <img src={Street} alt="" />
                    Street View
                  </button>
                </div> */}
              </div>

              {/* Right Thumbnail Grid */}
              <div className="side-thumbnails">
                {thumbImages.slice(0, 4).map((img, index) => (
                  <div
                    key={index}
                    className="thumb-box"
                    onClick={() => handleThumbClick(img)}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={img.imageUrl} alt={`Thumbnail ${index + 1}`} />
                    {index === 3 && thumbImages.length > 4 && (
                      <div className="more-overlay">
                        +{thumbImages.length - 4} more
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Property Info */}
        <div className="property-info contianer-fluid">
          <div className="row">
            <div className="col-md-8">
              <h2>{propertyName}</h2>
              <p className="pamp">
                <img src={Map} alt="" />
                {propertyData.unparsedAddress}
              </p>

              <div className="property-features" id="PropertyDetails">
                {/* Property Type */}
                {propertyData?.propertyType && (
                  <>
                    <div>
                      <img src={Home} alt="" />
                      <h5>Property Type</h5>
                      <h2>{propertyData.propertyType}</h2>
                    </div>
                    <strong></strong>
                  </>
                )}

                {/* Bedrooms */}
                {propertyData?.bedRooms && (
                  <>
                    <div>
                      <img src={BAD} alt="" />
                      <h5>Bedrooms</h5>
                      <h2>{propertyData.bedRooms}</h2>
                    </div>
                    <strong></strong>
                  </>
                )}

                {/* Bathrooms */}
                {propertyData?.bathroms && (
                  <>
                    <div>
                      <img src={BATH} alt="" />
                      <h5>Bathrooms</h5>
                      <h2>{propertyData.bathroms}</h2>
                    </div>
                    <strong></strong>
                  </>
                )}

                {/* Size */}
                {propertyData?.propertySize && (
                  <>
                    <div>
                      <img src={Size} alt="" />
                      <h5>Size</h5>
                      <h2>{propertyData.propertySize} ft²</h2>
                    </div>
                  </>
                )}
              </div>

              {/* <div className="address-details">
                <p>
                  <strong>Address:</strong> {propertyData.unparsedAddress}
                </p>
              </div> */}

              <div className="info-section container">
                <div className="row">
                  <div className="col-md-12" style={{ padding: "0" }}>
                    <div className="info-card bhfg info-cardsh">
                      {/* 1. Property Overview */}
                      <h5>1. Property Overview</h5>
                      <ul className="custom-list">
                        {propertyData?.listingKey && (
                          <li>
                            ListingKey:{" "}
                            <strong>{propertyData.listingKey}</strong>
                          </li>
                        )}

                        {propertyData?.propertySubType && (
                          <li>
                            PropertySubType:{" "}
                            <strong>{propertyData.propertySubType}</strong>
                          </li>
                        )}

                        {propertyData?.standardStatus && (
                          <li>
                            StandardStatus:{" "}
                            <strong>{propertyData.standardStatus}</strong>
                          </li>
                        )}

                        {propertyData?.commonInterest && (
                          <li>
                            CommonInterest:{" "}
                            <strong>{propertyData.commonInterest}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.structureType?.length > 0 && (
                          <li>
                            StructureType:{" "}
                            {propertyData.structureType.join(", ")}
                          </li>
                        )}

                        {propertyData?.propertyCondition?.length > 0 && (
                          <li>
                            PropertyCondition:{" "}
                            {propertyData.propertyCondition.join(", ")}
                          </li>
                        )}

                        {propertyData?.architecturalStyle?.length > 0 && (
                          <li>
                            ArchitecturalStyle:{" "}
                            {propertyData.architecturalStyle.join(", ")}
                          </li>
                        )}

                        {propertyData?.stories && (
                          <li>
                            Stories: <strong>{propertyData.stories}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.propertyAttachedYN !== null &&
                          propertyData?.propertyAttachedYN !== undefined && (
                            <li>
                              PropertyAttachedYN:{" "}
                              <strong>
                                {String(propertyData.propertyAttachedYN)}
                              </strong>
                            </li>
                          )}

                        {propertyData?.yearBuilt && (
                          <li>
                            YearBuilt: <strong>{propertyData.yearBuilt}</strong>{" "}
                          </li>
                        )}
                      </ul>

                      {/* 2. Location Details */}
                      <h5>2. Location Details</h5>
                      <ul className="custom-list">
                        {propertyData?.unparsedAddress && (
                          <li>
                            UnparsedAddress:{" "}
                            <strong>{propertyData.unparsedAddress}</strong>
                          </li>
                        )}

                        {propertyData?.streetNumber && (
                          <li>
                            StreetNumber:{" "}
                            <strong>{propertyData.streetNumber}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.streetDirPrefix && (
                          <li>
                            StreetDirPrefix:{" "}
                            <strong>{propertyData.streetDirPrefix}</strong>
                          </li>
                        )}

                        {propertyData?.streetName && (
                          <li>
                            StreetName:{" "}
                            <strong> {propertyData.streetName}</strong>
                          </li>
                        )}

                        {propertyData?.streetSuffix && (
                          <li>
                            StreetSuffix:{" "}
                            <strong>{propertyData.streetSuffix}</strong>
                          </li>
                        )}

                        {propertyData?.unitNumber && (
                          <li>
                            UnitNumber:{" "}
                            <strong>{propertyData.unitNumber}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.city && (
                          <li>
                            City: <strong>{propertyData.city}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.cityRegion && (
                          <li>
                            CityRegion:{" "}
                            <strong>{propertyData.cityRegion}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.stateOrProvince && (
                          <li>
                            StateOrProvince:{" "}
                            <strong>{propertyData.stateOrProvince}</strong>
                          </li>
                        )}

                        {propertyData?.postalCode && (
                          <li>
                            PostalCode:{" "}
                            <strong> {propertyData.postalCode}</strong>
                          </li>
                        )}

                        {propertyData?.country && (
                          <li>
                            Country: <strong>{propertyData.country}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.subdivisionName && (
                          <li>
                            SubdivisionName:{" "}
                            <strong>{propertyData.subdivisionName}</strong>
                          </li>
                        )}

                        {propertyData?.directions && (
                          <li>
                            Directions:{" "}
                            <strong>{propertyData.directions}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.municipality && (
                          <li>
                            Municipality:{" "}
                            <strong>{propertyData.municipality}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.latitude && (
                          <li>
                            Latitude: <strong> {propertyData.latitude}</strong>
                          </li>
                        )}

                        {propertyData?.longitude && (
                          <li>
                            Longitude: <strong>{propertyData.longitude}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.mapCoordinateVerifiedYN !== null &&
                          propertyData?.mapCoordinateVerifiedYN !==
                            undefined && (
                            <li>
                              MapCoordinateVerifiedYN:{" "}
                              <strong>
                                {String(propertyData.mapCoordinateVerifiedYN)}
                              </strong>
                            </li>
                          )}
                      </ul>

                      {/* 3. Price & Financial Info */}
                      <h5>3. Price & Financial Info</h5>
                      <ul className="custom-list">
                        {propertyData?.listPrice && (
                          <li>
                            ListPrice:{" "}
                            <strong> {propertyData.listPrice}</strong>
                          </li>
                        )}

                        {propertyData?.leaseAmount && (
                          <li>
                            LeaseAmount:{" "}
                            <strong> {propertyData.leaseAmount}</strong>
                          </li>
                        )}

                        {propertyData?.leaseAmountFrequency && (
                          <li>
                            LeaseAmountFrequency:{" "}
                            <strong>{propertyData.leaseAmountFrequency}</strong>
                          </li>
                        )}

                        {propertyData?.pricePerUnit && (
                          <li>
                            PricePerUnit:{" "}
                            <strong> {propertyData.pricePerUnit}</strong>
                          </li>
                        )}

                        {propertyData?.leasePerUnit && (
                          <li>
                            LeasePerUnit:{" "}
                            <strong> {propertyData.leasePerUnit}</strong>
                          </li>
                        )}

                        {propertyData?.taxAnnualAmount && (
                          <li>
                            TaxAnnualAmount:{" "}
                            <strong> {propertyData.taxAnnualAmount}</strong>
                          </li>
                        )}

                        {propertyData?.taxYear && (
                          <li>
                            TaxYear: <strong> {propertyData.taxYear}</strong>
                          </li>
                        )}

                        {propertyData?.totalActualRent && (
                          <li>
                            TotalActualRent:{" "}
                            <strong> {propertyData.totalActualRent}</strong>
                          </li>
                        )}

                        {propertyData?.offerStartingPrice && (
                          <li>
                            OfferStartingPrice:{" "}
                            <strong>{propertyData.offerStartingPrice}</strong>
                          </li>
                        )}

                        {propertyData?.originalEntryTimestamp && (
                          <li>
                            OriginalEntryTimestamp:{" "}
                            <strong>
                              {propertyData.originalEntryTimestamp}
                            </strong>
                          </li>
                        )}

                        {propertyData?.statusChangeTimestamp && (
                          <li>
                            StatusChangeTimestamp:{" "}
                            <strong>
                              {propertyData.statusChangeTimestamp}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 4. Home Features & Interior */}
                      <h5>4. Home Features & Interior</h5>
                      <ul className="custom-list">
                        {propertyData?.bedroomsTotal && (
                          <li>
                            BedroomsTotal:{" "}
                            <strong>{propertyData.bedroomsTotal}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.bedroomsAboveGrade && (
                          <li>
                            BedroomsAboveGrade:{" "}
                            <strong>{propertyData.bedroomsAboveGrade}</strong>
                          </li>
                        )}

                        {propertyData?.bedroomsBelowGrade && (
                          <li>
                            BedroomsBelowGrade:{" "}
                            <strong>{propertyData.bedroomsBelowGrade}</strong>
                          </li>
                        )}

                        {propertyData?.bathroomsTotalInteger && (
                          <li>
                            BathroomsTotalInteger:{" "}
                            <strong>
                              {propertyData.bathroomsTotalInteger}
                            </strong>
                          </li>
                        )}

                        {propertyData?.bathroomsPartial && (
                          <li>
                            BathroomsPartial:{" "}
                            <strong>{propertyData.bathroomsPartial}</strong>
                          </li>
                        )}

                        {propertyData?.livingArea && (
                          <li>
                            LivingArea:{" "}
                            <strong>{propertyData.livingArea}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.livingAreaUnits && (
                          <li>
                            LivingAreaUnits:{" "}
                            <strong> {propertyData.livingAreaUnits}</strong>
                          </li>
                        )}

                        {propertyData?.livingAreaSource && (
                          <li>
                            LivingAreaSource:{" "}
                            <strong> {propertyData.livingAreaSource}</strong>
                          </li>
                        )}

                        {propertyData?.livingAreaMinimum && (
                          <li>
                            LivingAreaMinimum:{" "}
                            <strong> {propertyData.livingAreaMinimum}</strong>
                          </li>
                        )}

                        {propertyData?.livingAreaMaximum && (
                          <li>
                            LivingAreaMaximum:{" "}
                            <strong>{propertyData.livingAreaMaximum}</strong>
                          </li>
                        )}

                        {propertyData?.aboveGradeFinishedArea && (
                          <li>
                            AboveGradeFinishedArea:{" "}
                            <strong>
                              {propertyData.aboveGradeFinishedArea}
                            </strong>
                          </li>
                        )}

                        {propertyData?.belowGradeFinishedArea && (
                          <li>
                            BelowGradeFinishedArea:{" "}
                            <strong>
                              {propertyData.belowGradeFinishedArea}
                            </strong>
                          </li>
                        )}

                        {propertyData?.basement?.length > 0 && (
                          <li>
                            Basement:{" "}
                            <strong>{propertyData.basement.join(", ")}</strong>{" "}
                          </li>
                        )}

                        {propertyData?.flooring?.length > 0 && (
                          <li>
                            Flooring:{" "}
                            <strong> {propertyData.flooring.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.fireplaceYN != null && (
                          <li>
                            FireplaceYN:{" "}
                            <strong>{String(propertyData.fireplaceYN)}</strong>
                          </li>
                        )}

                        {propertyData?.fireplacesTotal && (
                          <li>
                            FireplacesTotal:{" "}
                            <strong> {propertyData.fireplacesTotal}</strong>
                          </li>
                        )}

                        {propertyData?.fireplaceFeatures?.length > 0 && (
                          <li>
                            FireplaceFeatures:{" "}
                            <strong>
                              {propertyData.fireplaceFeatures.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 5. Building Details */}
                      <h5>5. Building & Construction Details</h5>
                      <ul className="custom-list">
                        {propertyData?.buildingAreaTotal && (
                          <li>
                            BuildingAreaTotal:{" "}
                            <strong> {propertyData.buildingAreaTotal}</strong>
                          </li>
                        )}

                        {propertyData?.buildingAreaUnits && (
                          <li>
                            BuildingAreaUnits:{" "}
                            <strong> {propertyData.buildingAreaUnits}</strong>
                          </li>
                        )}

                        {propertyData?.buildingFeatures?.length > 0 && (
                          <li>
                            BuildingFeatures:{" "}
                            <strong>
                              {propertyData.buildingFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.constructionMaterials?.length > 0 && (
                          <li>
                            ConstructionMaterials:{" "}
                            <strong>
                              {propertyData.constructionMaterials.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.foundationDetails?.length > 0 && (
                          <li>
                            FoundationDetails:{" "}
                            <strong>
                              {propertyData.foundationDetails.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.exteriorFeatures?.length > 0 && (
                          <li>
                            ExteriorFeatures:{" "}
                            <strong>
                              {propertyData.exteriorFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.roof?.length > 0 && (
                          <li>
                            Roof:{" "}
                            <strong> {propertyData.roof.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.accessibilityFeatures?.length > 0 && (
                          <li>
                            AccessibilityFeatures:{" "}
                            <strong>
                              {propertyData.accessibilityFeatures.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 6. Lot & Land */}
                      <h5>6. Lot & Land Information</h5>
                      <ul className="custom-list">
                        {propertyData?.lotSizeArea && (
                          <li>
                            LotSizeArea:{" "}
                            <strong>{propertyData.lotSizeArea}</strong>
                          </li>
                        )}

                        {propertyData?.lotSizeDimensions && (
                          <li>
                            LotSizeDimensions:{" "}
                            <strong>{propertyData.lotSizeDimensions}</strong>
                          </li>
                        )}

                        {propertyData?.lotSizeUnits && (
                          <li>
                            LotSizeUnits:{" "}
                            <strong> {propertyData.lotSizeUnits}</strong>
                          </li>
                        )}

                        {propertyData?.lotFeatures?.length > 0 && (
                          <li>
                            LotFeatures:{" "}
                            <strong>
                              {" "}
                              {propertyData.lotFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.fencing?.length > 0 && (
                          <li>
                            Fencing:{" "}
                            <strong> {propertyData.fencing.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.frontageLengthNumeric && (
                          <li>
                            FrontageLengthNumeric:{" "}
                            <strong>
                              {propertyData.frontageLengthNumeric}
                            </strong>
                          </li>
                        )}

                        {propertyData?.frontageLengthNumericUnits && (
                          <li>
                            FrontageLengthNumericUnits:{" "}
                            <strong>
                              {propertyData.frontageLengthNumericUnits}
                            </strong>
                          </li>
                        )}

                        {propertyData?.waterfrontFeatures?.length > 0 && (
                          <li>
                            WaterfrontFeatures:{" "}
                            <strong>
                              {propertyData.waterfrontFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.waterBodyName && (
                          <li>
                            WaterBodyName:{" "}
                            <strong> {propertyData.waterBodyName}</strong>
                          </li>
                        )}

                        {propertyData?.roadSurfaceType?.length > 0 && (
                          <li>
                            RoadSurfaceType:{" "}
                            <strong>
                              {propertyData.roaddSurfaceType?.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.irrigationSource?.length > 0 && (
                          <li>
                            IrrigationSource:{" "}
                            <strong>
                              {propertyData.irrigationSource.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 7. Utilities */}
                      <h5>7. Utilities & Systems</h5>
                      <ul className="custom-list">
                        {propertyData?.waterSource?.length > 0 && (
                          <li>
                            WaterSource:{" "}
                            <strong>
                              {propertyData.waterSource.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.sewer?.length > 0 && (
                          <li>
                            Sewer:{" "}
                            <strong> {propertyData.sewer.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.electric?.length > 0 && (
                          <li>
                            Electric:{" "}
                            <strong> {propertyData.electric.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.heating?.length > 0 && (
                          <li>
                            Heating:{" "}
                            <strong> {propertyData.heating.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.cooling?.length > 0 && (
                          <li>
                            Cooling:{" "}
                            <strong> {propertyData.cooling.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.utilities?.length > 0 && (
                          <li>
                            Utilities:{" "}
                            <strong>{propertyData.utilities.join(", ")}</strong>
                          </li>
                        )}

                        {propertyData?.otherEquipment?.length > 0 && (
                          <li>
                            OtherEquipment:{" "}
                            <strong>
                              {propertyData.otherEquipment.join(", ")}
                            </strong>
                          </li>
                        )}
                      </ul>

                      {/* 8. Community */}
                      <h5>8. Community & Neighborhood</h5>
                      <ul className="custom-list">
                        {propertyData?.communityFeatures?.length > 0 && (
                          <li>
                            CommunityFeatures:{" "}
                            <strong>
                              {propertyData.communityFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.possibleUse?.length > 0 && (
                          <li>
                            PossibleUse:{" "}
                            <strong>
                              {propertyData.possibleUse.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.currentUse?.length > 0 && (
                          <li>
                            CurrentUse:{" "}
                            <strong>
                              {" "}
                              {propertyData.currentUse.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.anchorsCoTenants && (
                          <li>
                            AnchorsCoTenants:{" "}
                            <strong> {propertyData.anchorsCoTenants}</strong>
                          </li>
                        )}
                      </ul>

                      {/* 9. Parking */}
                      <h5>9. Parking & Garage</h5>
                      <ul className="custom-list">
                        {propertyData?.parkingFeatures?.length > 0 && (
                          <li>
                            ParkingFeatures:{" "}
                            <strong>
                              {propertyData.parkingFeatures.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.parkingTotal && (
                          <li>
                            ParkingTotal:{" "}
                            <strong>{propertyData.parkingTotal}</strong>
                          </li>
                        )}
                      </ul>

                      {/* 10. HOA */}
                      <h5>10. Association (HOA) Details</h5>
                      <ul className="custom-list">
                        {propertyData?.associationFee && (
                          <li>
                            AssociationFee:{" "}
                            <strong> {propertyData.associationFee}</strong>
                          </li>
                        )}

                        {propertyData?.associationFeeFrequency && (
                          <li>
                            AssociationFeeFrequency:{" "}
                            <strong>
                              {propertyData.associationFeeFrequency}
                            </strong>
                          </li>
                        )}

                        {propertyData?.associationName && (
                          <li>
                            Association Name:{" "}
                            <strong> {propertyData.associationName}</strong>
                          </li>
                        )}

                        {propertyData?.associationFeeIncludes?.length > 0 && (
                          <li>
                            AssociationFeeIncludes:{" "}
                            <strong>
                              {propertyData.associationFeeIncludes.join(", ")}
                            </strong>
                          </li>
                        )}

                        {propertyData?.listAOR && (
                          <li>
                            ListAOR: <strong> {propertyData.listAOR}</strong>
                          </li>
                        )}

                        {propertyData?.listAORKey && (
                          <li>
                            ListAORKey:{" "}
                            <strong>{propertyData.listAORKey}</strong>
                          </li>
                        )}
                      </ul>

                      {/* 11. Agent Info */}
                      <h5>11. Listing & Agent Information</h5>
                      <ul className="custom-list">
                        {propertyData?.listingId && (
                          <li>
                            ListingId:{" "}
                            <strong> {propertyData.listingId}</strong>
                          </li>
                        )}

                        {propertyData?.listingURL && (
                          <li>
                            ListingURL:{" "}
                            <strong>{propertyData.listingURL}</strong>
                          </li>
                        )}

                        {propertyData?.originatingSystemName && (
                          <li>
                            OriginatingSystemName:{" "}
                            <strong>
                              {propertyData.originatingSystemName}
                            </strong>
                          </li>
                        )}

                        {propertyData?.listOfficeKey && (
                          <li>
                            ListOfficeKey:{" "}
                            <strong> {propertyData.listOfficeKey}</strong>
                          </li>
                        )}

                        {propertyData?.listAgentKey && (
                          <li>
                            ListAgentKey:{" "}
                            <strong> {propertyData.listAgentKey}</strong>
                          </li>
                        )}

                        {propertyData?.coListOfficeKey && (
                          <li>
                            CoListOfficeKey:{" "}
                            <strong> {propertyData.coListOfficeKey}</strong>
                          </li>
                        )}

                        {propertyData?.coListAgentKey && (
                          <li>
                            CoListAgentKey:{" "}
                            <strong> {propertyData.coListAgentKey}</strong>
                          </li>
                        )}

                        {propertyData?.internetEntireListingDisplayYN !==
                          undefined && (
                          <li>
                            InternetEntireListingDisplayYN:{" "}
                            <strong>
                              {String(
                                propertyData.internetEntireListingDisplayYN
                              )}
                            </strong>
                          </li>
                        )}

                        {propertyData?.internetAddressDisplayYN !==
                          undefined && (
                          <li>
                            InternetAddressDisplayYN:{" "}
                            <strong>
                              {String(propertyData.internetAddressDisplayYN)}
                            </strong>
                          </li>
                        )}

                        {propertyData?.originalEntryTimestamp && (
                          <li>
                            OriginalEntryTimestamp:{" "}
                            <strong>
                              {propertyData.originalEntryTimestamp}
                            </strong>
                          </li>
                        )}

                        {propertyData?.modificationTimestamp && (
                          <li>
                            ModificationTimestamp:{" "}
                            <strong>
                              {propertyData.modificationTimestamp}
                            </strong>
                          </li>
                        )}

                        {propertyData?.statusChangeTimestamp && (
                          <li>
                            StatusChangeTimestamp:{" "}
                            <strong>
                              {propertyData.statusChangeTimestamp}
                            </strong>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Slider */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <Slider />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Mylistingview;
